import React, { useEffect, useState } from 'react';
import ExcelJS from 'exceljs';
import {
    LoadingGrid,
    TableList,
} from '../../../../rbts/helpers';
import { useGetActivityLog } from '../hooks/ActivityLogHook';
import { dateFormatt, dateFormattTime } from '../../../../rbts/helpers/FormatDate';
import Select from 'react-select';
import { styleSelect } from '../../../../rbts/assets/ts/_utils/SelectUtil';

type Props = {};

const View: React.FC<Props> = () => {

    const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
    const [datesFilter, setDatesFilter] = useState<any>([]);
    const [dateValue, setDateValue] = useState('');
    const [collaboratorValue, setCollaboratorValue] = useState('')
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedCollaborator, setSelectedCollaborator] = useState(0);
    const { list, loadingRequest } = useGetActivityLog(reloadInfo, selectedDate, selectedCollaborator);
    const [collaboratorListFilter, setCollaboratorsListFilter] = useState<any>([]);

    useEffect(() => {
        if (list) {
            const fechas = list.map((option: any) => ({
                value: option.createdAt,
                label: dateFormatt(option.createdAt),
            }));

            const cleanDates = Array.from(
                new Map(fechas.map(f => [f.label, f])).values()
            );

            const collaborators = list.map((option: any) => ({
                value: option.collaborator.id,
                label: option.collaborator.email,
            }));

            const cleanCollaborators = Array.from(
                new Map(collaborators.map(f => [f.value, f])).values()
            );

            setDatesFilter(cleanDates)

            setCollaboratorsListFilter(cleanCollaborators)

        }
    }, [list]);

    const handleDateFilterChange = (selectedOption: any) => {
        if (selectedOption) {
            setDateValue(selectedOption);
            setSelectedDate(selectedOption.value)
        } else {
            setDateValue('');
            setSelectedDate('')
        }
    }

    const handleCollaboratorFilterChange = (selectedOption: any) => {
        if (selectedOption) {
            setCollaboratorValue(selectedOption);
            setSelectedCollaborator(selectedOption.value)
        } else {
            setCollaboratorValue('');
            setSelectedCollaborator(0)
        }
    }

    const columns: any = [
        {
            id: 'fecha',
            name: <div className="fw-bolder text-muted">Fecha</div>,
            selector: (row: any) => row.createdAt,
            cell: (row: any) => (
                <>
                    <span>{dateFormattTime(row.createdAt)}</span>
                </>
            ),
            sortable: true,
        },
        {
            id: 'colaborador',
            name: <div className="fw-bolder text-muted">Colaborador</div>,
            selector: (row: any) => row.collaborator.email,
            cell: (row: any) => (
                <>
                    <span className="fw-bolder ">
                        {row.collaborator.email}
                    </span>
                </>
            ),
            sortable: true,
        },

        {
            id: 'consulta',
            name: <div className="fw-bolder text-muted">Consulta</div>,
            selector: (row: any) => row.content,
            cell: (row: any) => (
                <>
                    <div className="fw-bolder">{row.content}</div>
                </>
            ),
            sortable: false,
        },
        {
            id: 'sucursal',
            name: <div className="fw-bolder text-muted">Sucursal</div>,
            selector: (row: any) => row.branch,
            cell: (row: any) => (
                <>
                    <div className="fw-bolder">{row.collaborator.branch}</div>
                </>
            ),
            sortable: false,
        },
    ];

    // DESCARGA EXCEL

    const [loadingDownload, setLoadingDownload] = React.useState(false);
    const columnsExcel: any = ['Fecha', 'Colaborador', 'Consulta', 'Sucursal'];
    const handleDownloadExcel = async () => {
        setLoadingDownload(true);
        try {
            await exportTableToExcel(list, columnsExcel, `registro_actividad.xlsx`);
        } catch (error) {
            console.error('Error downloading Excel:', error);
        } finally {
            setLoadingDownload(false);
        }
    };

    const exportTableToExcel = async (
        data: any[],
        columns: string[],
        filename = 'tabla.xlsx'
    ) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(`Registro actividad`);

        worksheet.addRow(['Fecha', 'Colaborador', 'Consulta', 'Sucursal']);
        worksheet.columns = [
            { width: 30 },
            { width: 30 },
            { width: 50 },
            { width: 30 },
        ];

        data.forEach((item) => {
            const fecha = dateFormattTime(item.createdAt);
            const collaborator = item.collaborator.email
            const consulta = item.content
            const sucursal = item.collaborator.branch
            worksheet.addRow([fecha, collaborator, consulta, sucursal]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <div className="d-flex flex-column flex-xl-row">
                <div className="col-xl-12">
                    <div className="card mb-6 mb-xl-9">
                        <div className="card-header border-0 pt-5">
                            <div className="card-title">
                                <div className="w-300px pe-5 fs-7 text-gray-700">
                                    <div className="w-100 d-flex">
                                        <label className="form-label w-auto">
                                            Fecha:{' '}
                                        </label>
                                    </div>
                                    <Select
                                        options={datesFilter}
                                        value={dateValue}
                                        styles={styleSelect}
                                        placeholder={'Seleccione'}
                                        className="w-100"
                                        isSearchable={true}
                                        noOptionsMessage={() => {
                                            return <span>{'No se encontraron registros'}</span>;
                                        }}
                                        onChange={handleDateFilterChange}
                                        isLoading={loadingRequest}
                                        isClearable
                                        backspaceRemovesValue
                                    />
                                </div>
                                <div className="w-300px pe-5 fs-7 text-gray-700">
                                    <div className="w-100 d-flex">
                                        <label className="form-label w-auto">
                                            Colaborador:{' '}
                                        </label>
                                    </div>
                                    <Select
                                        options={collaboratorListFilter}
                                        value={collaboratorValue}
                                        styles={styleSelect}
                                        placeholder={'Seleccione'}
                                        className="w-100"
                                        isSearchable={true}
                                        noOptionsMessage={() => {
                                            return <span>{'No se encontraron registros'}</span>;
                                        }}
                                        onChange={handleCollaboratorFilterChange}
                                        isLoading={loadingRequest}
                                        isClearable
                                        backspaceRemovesValue
                                    />
                                </div>
                                <div className="card-toolbar">
                                    <div className="d-flex rounded mt-1">
                                        {list.length > 0 && (
                                            <button
                                                className="btn btn-sm btn-light-success mt-7 ms-5"
                                                disabled={loadingDownload}
                                                onClick={() => handleDownloadExcel()}
                                            >
                                                {loadingDownload ? (
                                                    <span
                                                        className="indicator-progress"
                                                        style={{ display: 'block' }}
                                                    >
                                                        Descargando...
                                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                    </span>
                                                ) : (
                                                    <>
                                                        Descargar
                                                    </>
                                                )}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row gy-5 g-xl-8">
                                <div className="col-xl-12">
                                    {loadingRequest ? (
                                        <LoadingGrid text="Cargando..."></LoadingGrid>
                                    ) : (
                                        <>
                                            <TableList data={list} columns={columns}></TableList>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { View };
